import { Directive, Input, ElementRef, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { MatOptgroup } from '@angular/material/core';
import { Subject, takeUntil } from 'rxjs';

@Directive({
  selector: '[appOptgroupToggle]'
})
export class OptgroupToggleDirective implements OnInit, OnDestroy {
  @Input('appOptgroupToggle') initialState: boolean | '' = '';
  private optgroupElement: HTMLElement | null = null;
  private isExpanded = false;
  private readonly destroyed = new Subject<void>();

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    Promise.resolve().then(() => {
      this.optgroupElement = this.findOptgroupElement(this.el.nativeElement);
      if (this.optgroupElement) {
        if (typeof this.initialState === 'boolean') {
          this.isExpanded = this.initialState;
          this.setExpandedState(this.isExpanded);
        }
      } else {
        console.warn('appOptgroupToggle directive applied to an element that is not within a mat-optgroup.');
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  expand(): void {
    if (this.optgroupElement && !this.isExpanded) {
      this.setExpandedState(true);
      this.isExpanded = true;
    }
  }

  collapse(): void {
    if (this.optgroupElement && this.isExpanded) {
      this.setExpandedState(false);
      this.isExpanded = false;
    }
  }

  toggle(): void {
    if (this.optgroupElement) {
      this.isExpanded = !this.isExpanded;
      this.setExpandedState(this.isExpanded);
    }
  }

  private setExpandedState(expanded: boolean): void {
    const header = this.optgroupElement?.querySelector('.mat-optgroup-label');
    if (header) {
      if (expanded) {
        this.renderer.addClass(this.optgroupElement, 'mat-expanded');
      } else {
        this.renderer.removeClass(this.optgroupElement, 'mat-expanded');
      }
    }
  }

  private findOptgroupElement(element: HTMLElement): HTMLElement | null {
    let currentElement = element.parentElement;
    while (currentElement) {
      if (currentElement.tagName.toLowerCase() === 'mat-optgroup') {
        return currentElement;
      }
      currentElement = currentElement.parentElement;
    }
    return null;
  }
}